import React from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css';
import LaserFlow from './LaserFlow';

function Cancel() {
  const navigate = useNavigate();

  const handleReturnHome = () => {
    navigate('/', { replace: true });
  };

  return (
    <div className="app" style={{ background: '#000', position: 'relative', overflow: 'hidden' }}>
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1 }}>
        <LaserFlow
          horizontalBeamOffset={0.0}
          verticalBeamOffset={0.1}
          color="#9D1515"
          wispDensity={0.8}
          wispIntensity={4.0}
          fogIntensity={0.4}
          flowStrength={0.2}
        />
      </div>

      <div className="logo-container-small" style={{ zIndex: 20 }}>
        <img 
          src={'/ovr-logo.png'}
          alt="Ottawa Volleyball Revival" 
          className="logo-small"
        />
      </div>

      <div className="success-container">
        <div className="success-content">
          <h1 className="success-title">PAYMENT CANCELLED</h1>
          <p className="success-message">
            Your registration was not completed.
          </p>
          <p className="success-email">
            No charges were made to your account.
          </p>
          <button onClick={handleReturnHome} className="team-form-btn" style={{ marginTop: '30px' }}>
            TRY AGAIN
          </button>
        </div>
      </div>
    </div>
  );
}

export default Cancel;

